export default function TermsAndConditions() {
  return (
    <div
      style={{
        maxWidth: 768,
        margin: 'auto',
        paddingTop: 50,
        paddingBottom: 50
      }}
    >
      <h1>Terms & Conditions</h1>
      <p>
        This is a legal agreement between you and RadUp (a brand of Res Publica
        Pte Ltd ) for your purchase of one or more courses.
      </p>
      <p>
        These Terms and Conditions are governed and construed in accordance with
        Singapore laws and the parties submit to the exclusive jurisdiction of
        the Courts of Singapore.
      </p>
      <h3>General</h3>
      <p>
        A virtual classroom doesn’t need bricks, tables, chairs, projectors,
        large screens, a server room, and all that. For a diagnostic imaging
        course in a virtual classroom, you need to use your own computer,
        preferably and if possible, with an additional screen, and have a stable
        and good internet connection - as referred to in the registration
        process. The rest is taken care of by RadUp. By registering for a
        virtual course, you acknowledge the Terms and Conditions as outset in
        here.
      </p>
      <p>
        For on-prem courses, the set-up will be prepared. You just need to get
        to the venue.
      </p>
      <h3>Payments</h3>
      <p>
        An admin fee is charged upon check-out. Discount codes need to be
        entered during the check-out process, and before actual payment.
        Discounts cannot be applied retrospectively. RadUp cannot invoice for
        fees, or accept payments via transfer and instalments.
      </p>
      <h3>Cancellation policy</h3>
      <p>
        In case Participants cancel a course, there are costs involved. There
        might be a financial loss in course-take up if a cancellation is made
        shortly before delivery of the course since this seat cannot be taken by
        somebody else, etc. Therefore, bearing these considerations in mind the
        cancellation policy is as follow:
      </p>

      <ul>
        <li>
          Cancellations of less than 10 working days before the course receive
          no refund.
        </li>
        <li>
          Cancellations are exclusive of the administrative fee of 3.5% of the
          total amount paid.
        </li>
      </ul>
      <p>
        In case you want to cancel a booking, simply go to the confirmation
        email and hit the cancellation link. You will receive your refund via
        the credit card that was used for the payment between 5 - 10 working
        days.
      </p>
      <h3>No show</h3>
      <p>
        If you fail to attend the course for which you were registered without
        giving prior notice to RadUp, no refund can be provided.
      </p>
      <h3>Course cancellation</h3>
      <p>
        RadUp reserves the right to modify and /or cancel a course up to and
        including the day of the course in extreme circumstances. In case of
        cancellation of a course, the following applies:
      </p>
      <ul>
        <li>
          RadUp will try to reschedule the course and will inform you of the
          rescheduled dates;
        </li>
        <li>
          if RadUp is unable to reschedule the course you will be offered a free
          transfer to the next available course;
        </li>
        <li>
          if you are unable to attend the rescheduled date(s), you will receive
          a 100% refund of the fee;
        </li>
        <li>
          Refunds will be processed within 28 days of receiving your request
          either via credit card or bank transfer to the original payer.
        </li>
      </ul>
      <h3>Faculty Availability and Liability</h3>
      <p>
        RadUp shall use reasonable efforts to ensure that scheduled faculty
        members are available to facilitate the course as planned. However,
        circumstances may arise where a faculty member becomes unavailable due
        to illness, medical reasons, family emergencies, personal matters,
        travel disruption, or other unforeseen circumstances beyond RadUp’s
        reasonable control.
      </p>

      <p>
        In such circumstances, RadUp reserves the right, at its sole discretion,
        to:
      </p>
      <ul>
        <li>
          substitute the faculty member with another suitably qualified
          instructor;
        </li>
        <li>reschedule the course to an alternative date; or</li>
        <li>
          deliver the course in an adjusted format where reasonably necessary.
        </li>
      </ul>
      <p>
        The unavailability of a specific faculty member shall <b>not</b>{' '}
        constitute grounds for damages, compensation, or liability on the part
        of RadUp.
      </p>
      <p>
        To the fullest extent permitted by applicable law, RadUp shall{' '}
        <b>not be liable</b> for any indirect or consequential losses incurred
        by Participants or third parties arising from such substitution,
        postponement, or rescheduling, including but not limited to:
      </p>
      <ul>
        <li>transportation or travel costs;</li>
        <li>accommodation expenses;</li>
        <li>visa or travel arrangement costs;</li>
        <li>loss of income or business opportunity;</li>
        <li>lost working time;</li>
        <li>leave taken from employment; or</li>
        <li>any other personal or commercial expenses.</li>
      </ul>

      <p>
        Where a course must be rescheduled due to faculty unavailability and the
        Participant is unable to attend the revised date(s), RadUp’s sole
        obligation shall be limited to offering a transfer to a future course or
        providing a refund of the course fee in accordance with these Terms and
        Conditions. No additional compensation shall be payable.
      </p>

      <h3>Recording policy</h3>
      <p>
        The recording of course activities, and / or posting these to the
        internet without the specific written permission of RadUp is strictly
        prohibited.
      </p>
      <h3>Course materials</h3>
      <p>
        Course materials shared with participants before, during and after a
        course are the intellectual property of RadUp or third parties as
        identified by RadUp. A Participant can only make personal use of these
        materials and documents, and may not be copied or shared with others
        without written permission from RadUp. Note that RadUp reserves the
        right to change the course content of any Course at any time and without
        notice.
      </p>
      <h3>Copyright and intellectual property</h3>
      <p>
        A course is only intended for the person that has been registered for
        the course. The participant acknowledges that all intellectual property
        rights of the training materials and any documentation anywhere in the
        world belong to RadUp.{' '}
      </p>
      <p>
        Taking a course will not qualify the Participant to train others in the
        subject matter of the course. Any usage of the copyrighted course
        material to train others represents a violation of professional ethics
        and standards.{' '}
      </p>
      <p>
        A Participant also acknowledges that rights in the training materials
        and documentation are not sold to the participant, and that the
        participant has no rights in or to the training materials and
        documentation other than the right to use these in accordance with the
        terms of this course.
      </p>
      <h3>Faculty</h3>
      <p>
        RadUp provides the faculty to facilitate the course as it – at its sole
        discretion - deems fit. RadUp remains the right at any given time to
        substitute any faculty with any other person who - at RadUp’s sole
        discretion - deems suitably qualified to facilitate the respective
        course.
      </p>
      <h3>Technology</h3>
      <p>
        RadUp cannot and does not warrant that the provision of any content
        delivery will always be timely or error free, available or
        uninterrupted, and that errors and imperfections will be corrected or
        that such content is secure or free from bugs, viruses, errors and
        omissions.
      </p>
      <h3>Certificate</h3>
      <p>
        A certificate of completion will be provided to the Participant upon
        completion of the entire course. In case of partial completion, the
        certificate will make a pro-rated reference to the participated number
        of hours and/or days.
      </p>
      <h3>Force Majeure </h3>
      <p>
        With Force Majeure is meant any act, event, non-happening, omission or
        accident beyond reasonable control of RadUp.
      </p>
      <p>
        In the event of Force Majeure, RadUp will not be liable or responsible
        for any failure to perform, or delay in performance of any of our
        obligations that is caused by events outside our reasonable control.
      </p>
      <p>
        Our performance is deemed to be suspended for the period that the Force
        Majeure Event continues, and we will have an extension of time for
        performance for the duration of that period. RadUp will use reasonable
        endeavours to bring the Force Majeure Event to a close, or to find a
        solution by which our obligations may be performed despite the Force
        Majeure Event.
      </p>
      <h3>Right to change the Terms and Conditions </h3>
      <p>
        Whereas RadUp makes every effort to minimise changes to the Website,
        RadUp reserves the right to make any changes to the Terms and Conditions
        at any time to reflect changes affecting our business, including but not
        limited to: changes in payment methods, changes in technology, and legal
        and regulatory requirements. By continuing to use this Website you agree
        to accept any changes made to the terms and conditions
      </p>
      <p>
        <i>Last updated January 2026</i>
      </p>
    </div>
  )
}
